import { AxiosInstance } from "axios";
import toError from "../../../../common/helpers/toError";
import { Dispatch } from "redux";
import { IStateTree } from "../../interfaces";
import { showNotification } from "../../notification/actions";
import { DashboardActionTypes } from "../models/dashboardActions";
import { DELETE_PACK } from "../types";

export default (_id: string, callback: () => void) => async (dispatch: Dispatch<DashboardActionTypes>, getState: () => IStateTree, api: AxiosInstance) => {
    try {
        const res = await api.post<{ success: boolean }>("/delete-pack", { packId: _id });
        if (res.data.success) {
            dispatch({
                type: DELETE_PACK,
                payload: _id,
            });

            callback();
        }
    } catch (error) {
        dispatch(showNotification(toError(error).message, "warning"));
    }
};